import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {stateColor} from '../variables/index'
import {Badge, Tooltip} from 'antd'

class State extends Component {
  render() {
    const {value} = this.props
    return (
      <span {...this.props}>
        <Badge
          dot
          style={{
            background: stateColor[value],
          }}
        />
        <Tooltip title="State">
          <span style={{marginLeft: '10px'}}>{value}</span>
        </Tooltip>
      </span>
    )
  }
}

State.propTypes = {value: PropTypes.string.isRequired}
State.defaultProps = {value: ''}

export default State
